const componentsContext = import.meta.globEager('../components/**/*.(vue|js)');
const install = Vue => {
  Object.keys(componentsContext).forEach(component => {
    const componentConfig = componentsContext[component];
    const ctrl = componentConfig.default || componentConfig;
    if (ctrl.name) {
      Vue.component(ctrl.name, ctrl);
    }
  });
};
export default {
  install,
};
